import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Foundation from "@/pages/Foundation";

export const Route = createFileRoute("/es/sobre-qbd/fundacion")({
  head: () => buildRouteHead("/es/sobre-qbd/fundacion"),
  component: Foundation,
});

